export default class CampaignModel {
  own = false
  campaign_id = ''
  end_date = ''
  folder_id = ''
  folder_path = ''
  most_recent_cmp_action_date = ''
  most_recent_cmp_action_id = ''
  most_recent_mailing_date = ''
  most_recent_mailing_id = ''
  name = ''
  num_cmp_actions = ''
  num_mailings = ''
  oldest_cmp_action_date = ''
  oldest_cmp_action_id = ''
  oldest_mailing_date = ''
  oldest_mailing_id = ''
  start_date = ''
  type = ''
  user_id = ''
  user_name = ''
}
